import { RequestDiagnostics } from '../requestDiagnostics';

export interface ICommandResult {
    IsSuccess: boolean;
    Message: string;
}

export class CommandResult implements ICommandResult {
    IsSuccess: boolean;
    Message: string;
}

export interface ICommand<TResult extends ICommandResult> {
    CommandType: string;

    //This is just for TypeScript compiler... no use of it other way.
    __typeCall: (commandResult: TResult) => TResult;
}

export class Command<TResult extends ICommandResult> implements ICommand<TResult> {
    public CommandType = '';

    public constructor(commendType: string) {
        this.CommandType = commendType;
    }

    //This is just for TypeScript compiler... no use of it other way.
    public __typeCall(commandResult: TResult): TResult {
        return commandResult;
    }
}

export interface ICommandDispathcer {
    dispatchCommand<TCommand extends ICommand<TResult>, TResult extends ICommandResult>(command: TCommand, isCurrent?: () => boolean, diagnostics?: RequestDiagnostics): Promise<TResult>;
    abortAllCommand(): void;
}
